export default __webpack_public_path__ + "static/media/airlockz-bpk-1.4b9e0bfb.png";